// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","icon":"Footer_icon__Zscac","heart":"Footer_heart__Xm50u","beat":"Footer_beat__MpIC-"};